export default __webpack_public_path__ + "static/Sustentabilidade-b329701011f4d5a52da9b75e7a56fdd1.svg";